import React, { useEffect, useState } from "react";
import Usernav from "./Usernav";
import Sellernav from "./Sellernav";
import Adminnav from "./Adminnav";
import { useLocation } from "react-router-dom";
import "./OrderSummary.css";
import axios from "axios";
import GetProductName from "./GetProductName";
import BaseURL from "../Util/BaseURL";
import orderSuccess from "../assets/image/Order Successfull.svg"
const OrderSummary = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  async function getCartDetails() {
    const r = await axios.get(
      `${BaseURL}OrderDetails?number=${location.state.orderNo}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );

    setProducts(r.data);
  }

  useEffect(() => {
    getCartDetails();
  }, []);

  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo">
            <h1 className="font-weight-bold">Order Summary</h1>
          </div>
        </div>
      </section>
      <section className="">
        <div className="container">
          <div className="cart">
            <div className="table-responsive">
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Product
                    </th>
                    <th scope="col" className="text-white">
                      Price
                    </th>
                    <th scope="col" className="text-white">
                      Quantity
                    </th>
                    <th scope="col" className="text-white">
                      Total
                    </th>
                    <th scope="col" className="text-white">
                      Delivery Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {products
                    ? products.map((data,key) => (
                          <tr key={key}>
                            <td>
                              <GetProductName props={data.product_id} />
                              </td>
                            <td className="price">{data.price}</td>
                            <td className="quantity">{data.quantity}</td>
                            <td className="total">
                              {data.quantity * data.price}
                            </td>
                            {data.status === "Reached Distribution Hub" ? (
                                <td
                                  className="status"
                                  style={{ color: "green" }}
                                >
                                  <b>{data.status}</b>
                                </td>
                            ) : data.status === "Dispatached" ? (
                                <td
                                  className="status"
                                  style={{ color: "green" }}
                                >
                                  <b>Dispatched</b>
                                </td>
                            ) : (
                              <>
                                <td className="status" style={{ color: "red" }}>
                                  <b>Not Dispatched</b>
                                </td>
                              </>
                            )}
                          </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <img
                src={orderSuccess}
                className="d-block d-xl-none d-lg-none d-md-none"
                style={{ width: "100%" }}
              />
              <img
                src={orderSuccess}
                className="d-none d-xl-block d-lg-block d-md-block mx-auto"
                style={{ width: "35%" }}
              />
    </>
  );
};

export default OrderSummary;
